import Component from '@glimmer/component';
import { t } from 'ember-intl';
import SpaceCard from 'madow-tech/components/space-card';

export default class ScheduleCta extends Component {
  <template>
    <section id="schedule" class="py-16 md:py-20">
      <div class="mx-auto max-w-4xl px-4">
        <SpaceCard @variant="v1" class="text-center">
          <div class="py-6 md:py-10">
            <h3 class="text-2xl md:text-3xl font-bold mb-4">{{t "schedule.title"}}</h3>
            <p class="text-zinc-300 mb-8 max-w-xl mx-auto">{{t "schedule.intro"}}</p>
            <a
              href="https://calendly.com/madow-tech"
              target="_blank"
              rel="noopener noreferrer"
              class="sci-button v4 inline-flex items-center gap-2"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              {{t "schedule.cta"}}
            </a>
            <p class="text-xs text-zinc-500 mt-6">{{t "schedule.note"}}</p>
          </div>
        </SpaceCard>
      </div>
    </section>
  </template>
}




